import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";

const actionTexts = ["image: bauhaus", "\nimage: bauhaus colors", "image: "];

const imageTour: StepType[] = [
	{
		selector: ".author-root",
		position: "center",
		content: () => <TourStepContent description={() => <strong>{text.tourSteps.imagesTitle}</strong>} />,
		action: () => {
			fireClearCodeEvent();
		},
	},
	{
		selector: "#action-control-files",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesUploadedUnderFiles} />
		),
	},
	{
		selector: "#file-uploader",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesUploadAndName} />
		),
		action: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.imagesAddImagePrefix}{" "}
						<span className="qp-tour-modifier">image:</span> {text.tourSteps.imagesAddImageSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
			fireClearCodeEvent();
			const t = actionTexts[0];
			typeSomeText({ text: t, openAutoComplete: true });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesMultiple} />
		),
		action: () => {
			fireClearCodeEvent();

			const t = `\n${actionTexts[1]}`;
			typeSomeText({ text: actionTexts[0] + t, openAutoComplete: true });
		},
	},
];

export default imageTour;
